"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Checkbox = _interopRequireDefault(require("../checkbox/Checkbox"));
/**
 * Newsletter check box that prechecks if the region is AJP or ANA.
 */
const NewsletterCheckbox = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    register
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    id: "newsletter-opt",
    name: "newsletterOpt",
    ref: ref,
    register: register
  }, children);
});
NewsletterCheckbox.displayName = 'NewsletterCheckbox';
var _default = exports.default = NewsletterCheckbox;